var languageState = {
    key: null
};
export default languageState;
